import { Grid, styled } from "@mui/material";
import { SxProps, typography } from "@mui/system";


export const IconTable = styled(Grid, { label: "icon-table" })(({ theme }) => ({
  listStyle: "none",
  display: "flex",
  flexWrap: "wrap",
  "& li": {
    display: "flex",
    width: 270,
    height: 100,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    border: "1px solid #ccc",
    "& p": {
      marginBottom: 0,
    },
    '& img': {
      margin: '0 !important',
    },
  },

})
);

export const TitleDialog = styled("h2", { label: "TitleDialog" })(({ theme }) => ({
  color: 'inherit',
  marginTop: 0,
  textAlign: 'left',
  fontSize: 20,
  marginBottom: 6,

})
);